import { Injectable } from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';
import { tap } from 'rxjs/operators';
import { NotificationService } from '@proxy/notifications';

@Injectable({
  providedIn: 'root',
})
export class NotificationStateService {
  public unreadCount$ = new BehaviorSubject<number>(0);
  public openPanel$ = new Subject<void>();

  constructor(private notificationService: NotificationService) {}

  fetchInitialUnreadCount() {
    return this.notificationService.getUnreadCount().pipe(
        tap(count => this.unreadCount$.next(count))
    ).subscribe();
  }

  incrementUnreadCount() {
    const currentCount = this.unreadCount$.getValue();
    this.unreadCount$.next(currentCount + 1);
  }

  clearUnreadCount() {
    this.unreadCount$.next(0);
  }
}
